export default __webpack_public_path__ + "./images/er.999e5ac6.png";